import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

const roleColor = { ai: "bg-violet-50 text-violet-700 border-violet-200", client: "bg-blue-50 text-blue-700 border-blue-200", cpa: "bg-emerald-50 text-emerald-700 border-emerald-200", system: "bg-zinc-100 text-zinc-600 border-zinc-200" };

export default function AuditLogPage() {
  const { data: entries } = useQuery({ queryKey: ["audit"], queryFn: () => api.get("/audit?limit=200").then((r) => r.data) });

  return (
    <div className="p-8 space-y-6 fade-up" data-testid="audit-page">
      <div>
        <h1 className="font-heading text-2xl font-medium tracking-tight text-zinc-900">Audit Log</h1>
        <p className="text-sm text-zinc-500 mt-1">Immutable trail of all AI + user actions · SOC2-ready</p>
      </div>
      <div className="rounded-lg border border-zinc-200 bg-white overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-zinc-50">
              <TableHead className="text-xs">Timestamp</TableHead>
              <TableHead className="text-xs">Actor</TableHead>
              <TableHead className="text-xs">Role</TableHead>
              <TableHead className="text-xs">Action</TableHead>
              <TableHead className="text-xs">Details</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {(entries || []).map((a) => (
              <TableRow key={a.id} className="hover:bg-zinc-50 transition-colors duration-150">
                <TableCell className="font-mono text-[11px] text-zinc-500 whitespace-nowrap">{new Date(a.created_at).toLocaleString()}</TableCell>
                <TableCell className="text-xs text-zinc-700">{a.actor}</TableCell>
                <TableCell><span className={`text-[10px] uppercase px-1.5 py-0.5 rounded-sm border ${roleColor[a.actor_role] || "bg-zinc-100 text-zinc-600 border-zinc-200"}`}>{a.actor_role}</span></TableCell>
                <TableCell className="font-mono text-xs text-zinc-600">{a.action}</TableCell>
                <TableCell className="text-xs text-zinc-600 max-w-[400px] truncate">{a.details}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
